import React from 'react'

const Banner = ({ banner }) => {
    const background = banner?.background;
    return (
        <>

            <section className={`banner ${background.type === 'video' ? 'videobanner' : 'imagebanner'}`}>
                {background.type === 'video' ?
                    <div className='videofull'>
                        <video autoPlay playsInline muted loop>
                            <source src={background.url} type="video/mp4" />
                            Your browser does not support HTML video.
                        </video>
                    </div>
                    :
                    <div className="imagefull"></div>
                }

                <div className="container bannertext">
                    <div className="row">
                        <div className="col-md-7">
                            {/* <h1 className='heading'>{banner?.heading}</h1>
                            <p className='subheading'>{banner?.subHeading}</p>
                            <p className='paragraph'>{banner?.paragraph}</p> */}

                            <h1 className='heading' dangerouslySetInnerHTML={{ __html: banner?.heading }} />
                            <p className='subheading' dangerouslySetInnerHTML={{ __html: banner?.subHeading }} />
                            <p className='paragraph' dangerouslySetInnerHTML={{ __html: banner?.paragraph }} />


                        </div>
                    </div>
                </div>
            </section>
            <section className='aboutbann1 mt--130 '>
                <div className="container">
                    <div className="row justify-content-center text-center">
                        <div className="col-md-10">
                            <div className='aboutbn bg-white rounded-3'>
                                {/* {banner?.heading2}
                                <p>{banner?.subHeading2}</p> */}

                                 <div className='heading' dangerouslySetInnerHTML={{ __html: banner?.heading2 }} />
                                 <p dangerouslySetInnerHTML={{ __html:banner?.subHeading2 }} />

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Banner
